import { template as template_cc2eca6b684743dcbd2150ba3c79eb88 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { StrokeOptions } from 'eflex/constants/work-instructions/tool-props';
import { generateStrokeDashArray } from 'eflex/util/stroke-helper';
import { isBlank } from 'ramda-adjunct';
import PowerSelect from 'eflex/components/power-select';
import { t } from 'ember-intl';
import ColorOpacity from 'eflex/components/inputs/color-opacity';
import NumberControl from 'eflex/components/bs-form/element/control/number';
export default class ToolPropertiesDynamicObjectConfigToggle extends Component {
    _applyStroke = (style, width)=>{
        this.args.updateStroke(generateStrokeDashArray(style, width), style, width);
    };
    _updateStrokeStyle = (stroke)=>{
        this._applyStroke(stroke, this.args.strokeWidth);
    };
    _updateStrokeWidth = (strokeWidth)=>{
        if (this.args.strokeStyle) {
            const clampedWidth = isNaN(strokeWidth) ? this.min : Math.min(Math.max(strokeWidth, this.min), this.max);
            this._applyStroke(this.args.strokeStyle, clampedWidth);
        } else {
            this.args.updateStrokeWidth?.(strokeWidth);
        }
    };
    get min() {
        return this.args?.min || 0;
    }
    get max() {
        return this.args?.max || 100;
    }
    static{
        template_cc2eca6b684743dcbd2150ba3c79eb88(`
    <div class="row align-items-end gy-3" ...attributes>
      <div class="col-6">
        <label class="form-label fw-normal">
          {{t "imageEditor.stroke"}}
        </label>
        <ColorOpacity
          class="stroke-properties"
          @selectedColor={{@strokeColor}}
          @selectedOpacity={{@strokeOpacity}}
          @hideOpacity={{isBlank @strokeOpacity}}
          @updateColor={{@updateStrokeColor}}
          @isStroke={{true}}
          @disabled={{@disabled}}
        />
      </div>
      <div class="col-auto">
        <NumberControl
          class="stroke-width-input"
          @value={{@strokeWidth}}
          min={{this.min}}
          max={{this.max}}
          @onChange={{this._updateStrokeWidth}}
          @disabled={{@disabled}}
          @units="px"
        />
      </div>
      {{#if @strokeStyle}}
        <div class="col-6">
          <PowerSelect
            @dropdownClass="stroke-style-options"
            @options={{StrokeOptions.options}}
            @onChange={{this._updateStrokeStyle}}
            @selected={{@strokeStyle}}
            @disabled={{@disabled}}
            @matchTriggerWidth={{true}}
            class="stroke-style-select"
          as |style|>
            <div class="d-flex align-items-center w-100 me-3">
              <label data-style={{style}} class="stroke-option {{style}} flex-fill" />
              <span class="text-capitalize w-50 ms-2">{{style}}</span>
            </div>
          </PowerSelect>
        </div>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
